"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { SliderPrev } from "./SliderPrev";
import { SliderNext } from "./SliderNext";

const _interactionsData = JSON.parse(
  '{"events":{"e-57":{"id":"e-57","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-29","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-58"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"94f431fd-2c00-3080-9dc3-2c17ec68ab63","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"94f431fd-2c00-3080-9dc3-2c17ec68ab63","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1706135723689},"e-58":{"id":"e-58","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-57"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"94f431fd-2c00-3080-9dc3-2c17ec68ab63","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"94f431fd-2c00-3080-9dc3-2c17ec68ab63","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1706135723689}},"actionLists":{"a-29":{"id":"a-29","title":"slider - hover 4","actionItemGroups":[{"actionItems":[{"id":"a-29-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".div-block-25","selectorGuids":["1abe4ec2-60c9-41c5-d2c1-bd3f2e916401"]},"value":"none"}}]},{"actionItems":[{"id":"a-29-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".div-block-25","selectorGuids":["1abe4ec2-60c9-41c5-d2c1-bd3f2e916401"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702007975249},"a-30":{"id":"a-30","title":"slider - hover - hide arrows 4","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".div-block-25","selectorGuids":["1abe4ec2-60c9-41c5-d2c1-bd3f2e916401"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702008060190}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PropertyCardVertical({
  as: _Component = _Builtin.Block,
  name = "name",
  address = "Address, City, State, Zip",
  bedrooms = "1 & 2",
  startingPrice = "$1,144",
  amenitySlot,
  slideSlot,

  linkProps = {
    href: "#",
  },
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <_Component className="card_component" tag="div">
      <_Builtin.Block className="div-block-60" tag="div">
        <_Builtin.Block className="card_carousel" tag="div">
          {slideSlot ?? (
            <_Builtin.SliderWrapper
              className="slider-3"
              data-w-id="94f431fd-2c00-3080-9dc3-2c17ec68ab63"
              navSpacing={2}
              navShadow={false}
              autoplay={false}
              delay={4000}
              iconArrows={true}
              animation="slide"
              navNumbers={false}
              easing="ease"
              navRound={true}
              hideArrows={false}
              disableSwipe={false}
              duration={500}
              infinite={true}
              autoMax={0}
              navInvert={false}
            >
              <_Builtin.SliderMask>
                <_Builtin.SliderSlide tag="div">
                  <_Builtin.Block
                    className="card_slider-image-wrapper"
                    tag="div"
                  >
                    <_Builtin.Image
                      className="card_slider-image"
                      loading="lazy"
                      width="232"
                      height="159"
                      src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728684e34d594a0d7a12e4_Rectangle-112.png"
                    />
                  </_Builtin.Block>
                </_Builtin.SliderSlide>
                <_Builtin.SliderSlide tag="div">
                  <_Builtin.Block
                    className="card_slider-image-wrapper"
                    tag="div"
                  >
                    <_Builtin.Image
                      className="card_slider-image"
                      loading="lazy"
                      width="232"
                      height="159"
                      src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728684e34d594a0d7a12e4_Rectangle-112.png"
                    />
                  </_Builtin.Block>
                </_Builtin.SliderSlide>
                <_Builtin.SliderSlide tag="div">
                  <_Builtin.Block
                    className="card_slider-image-wrapper"
                    tag="div"
                  >
                    <_Builtin.Image
                      className="card_slider-image"
                      loading="lazy"
                      width="232"
                      height="159"
                      src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728684e34d594a0d7a12e4_Rectangle-112.png"
                    />
                  </_Builtin.Block>
                </_Builtin.SliderSlide>
              </_Builtin.SliderMask>
              <_Builtin.SliderArrow className="left-arrow-3" dir="left">
                <SliderPrev />
              </_Builtin.SliderArrow>
              <_Builtin.SliderArrow className="right-arrow-3" dir="right">
                <SliderNext />
              </_Builtin.SliderArrow>
              <_Builtin.SliderNav className="slide-nav-2" />
            </_Builtin.SliderWrapper>
          )}
        </_Builtin.Block>
        <_Builtin.Link
          className="link-block-3"
          button={false}
          block="inline"
          options={linkProps}
        >
          <_Builtin.Block className="card_content" tag="div">
            <_Builtin.Block tag="div">
              <_Builtin.Block className="card_name" tag="div">
                {name}
              </_Builtin.Block>
              <_Builtin.Block className="card_address" tag="div">
                <_Builtin.Image
                  className="vectors-wrapper-15"
                  loading="lazy"
                  width="9"
                  height="13"
                  src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728687c8a1b4c6aab7697d_Vectors-Wrapper.svg"
                />
                <_Builtin.Block className="text-size-xtiny" tag="div">
                  {address}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block className="card_amenities" tag="div">
              {amenitySlot ?? (
                <>
                  <_Builtin.Block tag="div" />
                  <_Builtin.Block tag="div" />
                </>
              )}
            </_Builtin.Block>
            <_Builtin.Block className="card_details" tag="div">
              <_Builtin.Block className=" bedrooms" tag="div">
                <_Builtin.Block className=" text-39" tag="div">
                  {"STARTING AT"}
                </_Builtin.Block>
                <_Builtin.Block className=" text-size-xtiny" tag="div">
                  {startingPrice}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block className="bedrooms" tag="div">
                <_Builtin.Block className="text-39" tag="div">
                  {"bedrooms"}
                </_Builtin.Block>
                <_Builtin.Block className="text-size-xtiny" tag="div">
                  {bedrooms}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Link>
      </_Builtin.Block>
    </_Component>
  );
}
